import { useTranslation } from 'react-i18next'
import { Avatar } from '../Avatar'
import { Badge } from '../Badge'
import { Btn } from '../Btn'
import { Icon } from '../Icon'
import { RegenCountdown } from '../RegenCountdown'

export type HeroState = 'unplayed' | 'played' | 'record' | 'lowStamina'

export interface HeroCardProps {
  state: HeroState
  score?: number
  rank?: number
  regenSeconds?: number
  firstName: string
  /** Telegram WebApp.initDataUnsafe.user.photo_url, if available. */
  photoUrl?: string
  /** Right-side inline CTA when state === 'unplayed'. */
  onStart?: () => void
  /** Right-side share icon when state === 'played' | 'record'. */
  onShare?: () => void
}

export function HeroCard({
  state,
  score,
  rank,
  regenSeconds = 0,
  firstName,
  photoUrl,
  onStart,
  onShare,
}: HeroCardProps) {
  const { t } = useTranslation()

  return (
    <div className="herocard">
      <Avatar
        name={firstName}
        size={64}
        color="#FFFFFF"
        photo_url={photoUrl}
        style={{ color: 'var(--apple-red)' }}
      />
      <div className="herocard__text">
        <div className="herocard__hi">{t('lobby.heroHi', { name: firstName })}</div>
        <div className="herocard__state">
          {state === 'unplayed' && t('lobby.heroUnplayed')}
          {state === 'played' && t('lobby.heroDone', { score, rank })}
          {state === 'record' && (
            <>
              {t('lobby.heroRecord', { score })}
              <Badge variant="new"> ⭐</Badge>
            </>
          )}
          {state === 'lowStamina' && (
            <>
              {t('lobby.heroNoStamina', { time: '' })}
              <RegenCountdown seconds={regenSeconds} />
            </>
          )}
        </div>
      </div>

      {state === 'unplayed' && (
        <Btn variant="outline-white" style={{ alignSelf: 'center' }} onClick={onStart}>
          {t('lobby.heroStart')} →
        </Btn>
      )}
      {(state === 'played' || state === 'record') && (
        <Btn
          variant="outline-white"
          aria-label="share"
          style={{ width: 40, padding: 0, alignSelf: 'center' }}
          onClick={onShare}
        >
          <Icon name="share" size={18} color="#fff" />
        </Btn>
      )}
    </div>
  )
}
